import React from "react";
import { isMobile } from "react-device-detect";

import StateSearchResultsMobile from "./StateSearchResultsMobile";
import StateSearchResultsDesktop from "./StateSearchResultsDesktop";

function StateSearchResults(props) {
  return isMobile ? <StateSearchResultsMobile {...props} /> : <StateSearchResultsDesktop {...props} />;
}

export default StateSearchResults;
